/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockCheck = createReactComponent("clock-check", "IconClockCheck", [
  ["path", { d: "M20.942 13.021a9 9 0 1 0 -9.407 7.967", key: "svg-0" }],
  ["path", { d: "M12 7v5l3 3", key: "svg-1" }],
  ["path", { d: "M15 19l2 2l4 -4", key: "svg-2" }]
]);

export { IconClockCheck as default };
//# sourceMappingURL=IconClockCheck.js.map
